import deleteSiteMeta from '../base-saving-actions/delete-site-meta';

const deleteCustomColorPalettes = (paletteIds) =>
  paletteIds.map((id) => deleteSiteMeta(['customization', 'customColorPalettes', id]));

export default deleteCustomColorPalettes;
